export class Cfs {
  id?: number;
  cfsCode: string;
}
